export const locationHost = process.env.NODE_ENV === 'production' ? "https://www.jihainet.com/" : 'http://localhost:8080';
// export const locationHost = process.env.NODE_ENV === 'production' ? "http://gw.jihainet.com/" : 'http://localhost:8080';
// export const locationHost = process.env.NODE_ENV === 'production' ? "http://www.guanwang.com/" : 'http://localhost:8080';


export const apiBaseUrl = 'https://www.jihainet.com/';
// export const apiBaseUrl = 'http://gw.jihainet.com/';
// export const apiBaseUrl = 'http://www.guanwang.com/';




